import React from 'react';
import styles from './photos.module.css';
import { Box, Typography } from '@mui/material';
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
import CircleIcon from '../../../../../components/circleIcon/CircleIcon';
import ColorPalette from '../../../../../colorpalette/ColorPalette';
import CranialPhotoCompare from './CranialPhotoCompare';
import { filterCranialPhotos } from './cranialPhotoViews';

/**
 * Seção "Antes e depois" do card de assimetria craniana, abaixo da tabela de
 * medições. Mostra só as duas pontas (primeira × última medição com foto) de
 * cada vista; as fotos das medições intermediárias ficam na coluna "Fotos"
 * da tabela.
 *
 * @param {Array} entries medições do histórico
 * @param {Array} photos anexos de context 'cranial_photo'
 * @param {boolean} enabled permite editar e excluir
 * @param {function} onChanged recarrega a lista de fotos do card
 */
const CranialPhotos = ({ entries, photos, enabled, onChanged }) => {
    const list = filterCranialPhotos(photos);

    return (
        <Box className={styles.section}>
            <Box className={styles.sectionHeader}>
                <Typography component="span" className={styles.sectionTitle}>
                    {`Antes e depois (${list.length})`}
                </Typography>
            </Box>

            {list.length === 0 ? (
                <Box className={styles.emptyState}>
                    <CircleIcon
                        style={"info"}
                        icon={<PhotoCameraOutlinedIcon style={{ color: ColorPalette.blueMain }} />}
                    />
                    <Typography variant="body1" sx={{ color: ColorPalette.textMedium, fontWeight: 400 }}>
                        Nenhuma foto registrada. Adicione fotos às medições para acompanhar a evolução.
                    </Typography>
                </Box>
            ) : (
                <CranialPhotoCompare
                    entries={entries}
                    photos={list}
                    enabled={enabled}
                    onChanged={onChanged}
                />
            )}
        </Box>
    );
};

export default CranialPhotos;
